import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { msg } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import Button from 'Root/Component/Button'

interface Props {
  onRemoveCallback: () => void
  rowNameId: string
}

const RemoveButton = ({ onRemoveCallback, rowNameId }: Props) => {
  const { _ } = useLingui()

  return (
    <Button
      variant="danger-tonal"
      iconOnly
      aria-label={_(msg`Rimuovi accesso`)}
      aria-describedby={rowNameId}
      iconLeft={<FontAwesomeIcon icon={faTrashAlt} />}
      onClick={onRemoveCallback}
    />
  )
}

export default RemoveButton
